import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import { useMemo } from 'react';
import '../useEventListener/c3560e46908f7d0b3c87fb45bf97bba8a41c7f11b9b9cc6ce5177ecd19c06ee3.cfe-internal.js';
import useEventListener from '../useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';

/**
 * Listens for a `mousedown` or `touchstart` event that exists outside of the given ref element(s).
 * @param refs - The ref elements to ignore events on.
 * @param onClickOutside - An observer that is called when an outside click or touch occurs.
 */
function useClickOutside(refs, onClickOutside) {
  var allRefs = useMemo(function () {
    return _Array$isArray(refs) ? refs : [refs];
  }, [refs]);
  var handler = function handler(event) {
    var isInside = _someInstanceProperty(allRefs).call(allRefs, function (ref) {
      var _el$contains;
      var el = ref.current;
      return el === null || el === void 0 || (_el$contains = el.contains) === null || _el$contains === void 0 ? void 0 : _el$contains.call(el, event.target);
    });
    if (!isInside) {
      onClickOutside(event);
    }
  };
  useEventListener(document, 'mousedown', handler);
  useEventListener(document, 'touchstart', handler);
}

export { useClickOutside as default };
